import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Header, Button, Icon, Segment, Message } from 'semantic-ui-react';
import UniversalMessagingTest from '../../components/messaging/UniversalMessagingTest';
import { MessageProvider } from '../../components/messaging/MessageProvider';

/**
 * Enhanced Messaging Test Page
 * Wrapper page for the Enhanced Universal Messaging Test System
 */
const EnhancedMessagingTest = () => {
  return (
    <MessageProvider>
      <Container fluid style={{ padding: '20px' }}>
        {/* Navigation Header */}
        <div className='center-container' >
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Header as="h1" style={{ margin: 0 }}>
              <Icon name="lab" color="blue" />
              Enhanced Universal Messaging Test Lab
            </Header>
            <Button
              as={Link}
              to="/messaging-test"
              icon="arrow left"
              content="Back to Basic Messaging Test"
              color="grey"
            />
          </div>
          <Message info style={{ marginTop: '15px' }}>
            <Message.Header>Enhanced Testing Features</Message.Header>
            <Message.List>
              <Message.Item>
                <strong>Realistic Business Scenarios:</strong> Test with industry-standard voice actor applications,
                financial transactions, and project milestones
              </Message.Item>
              <Message.Item>
                <strong>User Persona Switching:</strong> Switch between different user roles (Voice Actors, Book Creators, Admins)
                to test complete business workflows
              </Message.Item>
              <Message.Item>
                <strong>Industry Pricing Models:</strong> Automatic rate calculations based on project complexity,
                experience levels, and market factors ($150-$2500+ PFH)
              </Message.Item>
              <Message.Item>
                <strong>Persistent Configuration:</strong> All test data saves between browser sessions with
                export/import capabilities for team collaboration
              </Message.Item>
              <Message.Item>
                <strong>Intelligent Auto-Fill:</strong> Smart recipient suggestions and message templates
                based on business logic and user roles
              </Message.Item>
            </Message.List>
          </Message>
        </div>

        {/* Enhanced Test System */}
        <UniversalMessagingTest />
      </Container>
    </MessageProvider>
  );
};

export default EnhancedMessagingTest;
